<template>
    <div class="horizontal-stacked-chart">
        <div :id="'popup'+id" style="display: none;" v-tippy-html>
            <div v-if="hoveredNode" class="popover-content">
                <h4>{{hoveredNode.key}}</h4>
                <div class="amount">{{moneyFormatter(hoveredNode[0].data[hoveredNode.key])}}</div>
                <div class="percentage">{{numeral(hoveredNode[0].data[hoveredNode.key] / total).format('0.00%')}}</div>
            </div>
        </div>
        <svg :width="width" :height="height" :viewBox="'0 0 '+width+' '+height">
            <g>
                <g v-for="d in stackedData">
                    <g v-for="d2 in d" @mouseenter="hoveredNode = d" v-tippy="{html: '#popup'+id, followCursor: true, arrow: true, animation: 'fade'}">
                        <title>{{d.key}}</title>
                        <rect :x="x(d2[0])" :width="x(d2[1])" :height="height" :fill="color(d.key)"></rect>
                    </g>
                </g>
            </g>

        </svg>
    </div>

</template>
<script>
    import * as d3 from 'd3';
    import _ from 'lodash';
    import numeral from 'numeral';
    import moneyFormatter from '../../Methods/MoneyFormatter';

    export default {
        data: function(){
            return {
                id: Math.round(Math.random() * 10000000),
                hoveredNode: null,
            }
        },
        props: {
            width: {default: 300},
            height: {default: 40},
            data: {},
            dimensions: {},
            color: {
                default: function(){
                    return d3.scaleOrdinal(d3.schemeCategory10);
                }
            }
        },
        methods:{
            numeral: numeral,
            moneyFormatter: moneyFormatter
        },
        computed: {
            computedData: function(){
                return _(this.data)
                    .groupBy(this.dimensions.ordinal[0])
                    .map((d,key) => {
                        const data = {ordinal1: key};
                        d.forEach(d2 => {
                            data[d2['nombre_'+this.dimensions.ordinal[1]]] = d2.sum;
                        });

                        return data;
                    })
                    .value();

            },
            stackedData: function(){
                return this.stack(this.computedData);
            },
            total: function(){
                return _.sumBy(this.data, 'sum')
            },
            x: function(){
                return d3.scaleLinear()
                    .range([0, this.width])
                    .domain([0, d3.sum(this.data, d => {return d.sum})])
            },
            stack: function(){
                return d3.stack()
                    .keys(this.data.map(d => {return d['nombre_'+this.dimensions.ordinal[1]]}))
            },
            /*
            color: function(){
                return d3.scaleOrdinal(d3.schemeCategory10);
            }
            */
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Charts/HorizontalStacked.vue